<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <app-progress-bar [routeName]="routeName"></app-progress-bar>
    <main class="vtz-declaration-container">
      <div class="vtz-declaration-justify" [innerHtml]="declarationText"></div>
      <fieldset>
        <legend
          aria-label="Declaration page Please read the declaration contained on this page then Agree to one of the following options or Exit to quit."
          i18n-aria-label="Declaration page Please read the declaration contained on this page then Agree to one of the following options or Exit to quit."
          class="vtz-text--small" i18n>Please select one of the options below:</legend>
        <div role="radiogroup">
          @if(ovalOnRight){
          <label class="vtz-checkbox-container-declaration" [ngClass]="{'vtz-checkbox-container--checked': agreeChecked ,
            'vtz-checkbox-container--focused-declaration': agreeFocused}">
            <span class="vtz-checkbox-text vtz-text vtz-text--small" i18n>I agree.</span>
            <input [checked]="agreeChecked" id="agree" type="checkbox" on-focus="focusChoice(1)" (blur)='onBlur(1)'
              name="agree" value="0" (change)="checkAgree()" />
            <span class="vtz-checkbox__checkmark"></span>
          </label>

          <label class="vtz-checkbox-container-declaration" [ngClass]="{'vtz-checkbox-container--checked': declineChecked,
            'vtz-checkbox-container--focused-declaration': declineFocused}">
            <span class="vtz-checkbox-text  vtz-text vtz-text--small vtz-text-declaration " i18n>I agree, but decline to
              vote in this election.</span>
            <input [checked]="declineChecked" id="decline" type="checkbox" name="decline" on-focus="focusChoice(2)"
              (blur)='onBlur(2)' value="1" (change)="checkDecline()" />
            <span class="vtz-checkbox__checkmark"></span>
          </label>
          }
          @if(!ovalOnRight){
          <label class="vtz-checkbox-container-declaration-left"
            [ngClass]="{'vtz-checkbox-container--checked': agreeChecked ,'vtz-checkbox-container--focused-declaration': agreeFocused}">
            <input type="checkbox" id="agree" class="round-checkbox" [checked]="agreeChecked" on-focus="focusChoice(1)"
              (blur)='onBlur(1)' name="agree" value="0" (change)="checkAgree()" />
            <span class="vtz-checkbox-text vtz-text vtz-text--small" i18n>I agree.</span>
          </label>
          <label class="vtz-checkbox-container-declaration-left"
            [ngClass]="{'vtz-checkbox-container--checked': declineChecked ,'vtz-checkbox-container--focused-declaration': declineFocused}">
            <input type="checkbox" id="agree" class="round-checkbox" [checked]="declineChecked"
              on-focus="focusChoice(2)" (blur)='onBlur(2)' name="agree" value="1" (change)="checkDecline()" />
            <span class="vtz-checkbox-text  vtz-text vtz-text--small vtz-text-declaration " i18n>I agree, but decline to
              vote in this election.</span>
          </label>
          }

        </div>
      </fieldset>
      <div style="display: flex; justify-content: space-around; padding-top: 50px;">
        <button id="exit" class="button-secondary" (click)="exit()" i18n>EXIT</button>
        <button [disabled]="!agreeChecked && !declineChecked" id="declaration-next" class="button-primary"
          (click)="next()" i18n>PROCEED</button>
      </div>
    </main>
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>